import { CheckmarkCircleIcon } from '@carboncopyco/icons';
import { notify } from '@carboncopyco/ui';
import { FileServiceEventsEnum } from '../../shared/enums/FileServiceEventsEnum';
import useElectronListener from './useElectronListener';
import { useTabs } from '../store/context';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useState } from 'react';

interface Props {
  tabId: IGlobalTab['id'];
}

export const useFileService = (props?: Props) => {
  const { activeGlobalTab } = useTabs();
  const [downloadCompletedLabel, setDownloadCompletedLabel] =
    useState('File downloaded');
  const [downloadCompletedActionLabel, setDownloadCompletedActionLabel] =
    useState('Open');

  const isTabActive = activeGlobalTab.id === props?.tabId;

  const setLabels = (
    downloadCompletedLabel?: string,
    downloadCompletedActionLabel?: string
  ) => {
    if (downloadCompletedLabel) {
      setDownloadCompletedLabel(downloadCompletedLabel);
    }
    if (downloadCompletedActionLabel) {
      setDownloadCompletedActionLabel(downloadCompletedActionLabel);
    }
  };

  const downloadFileFromUrl = (
    fileUrl: string,
    downloadCompletedLabelArg?: string,
    downloadCompletedActionLabelArg?: string
  ) => {
    setLabels(downloadCompletedLabelArg, downloadCompletedActionLabelArg);

    window.dsDesktop?.fileService?.downloadFileFromUrl(fileUrl);
  };

  const downloadCsvFile = (
    csvContent: string,
    fileName: string,
    downloadCompletedLabelArg?: string,
    downloadCompletedActionLabelArg?: string
  ) => {
    setLabels(downloadCompletedLabelArg, downloadCompletedActionLabelArg);
    window.dsDesktop?.fileService?.downloadCsvFile(csvContent, fileName);
  };

  const openFile = (fileUrl: string) => {
    window.dsDesktop?.fileService?.openFile(fileUrl);
  };

  useElectronListener(
    FileServiceEventsEnum.MAIN_TO_RENDERER_FILE_DOWNLOAD_COMPLETED,
    (filePath: string) => {
      if (!isTabActive) {
        return;
      }
      notify.snackbar({
        type: 'success',
        label: downloadCompletedLabel ?? 'File downloaded',

        linkLabel: downloadCompletedActionLabel ?? 'Open',
        linkCB: () => {
          openFile(filePath);
        },
        iconName: <CheckmarkCircleIcon size={16} />,
      });
    }
  );

  useElectronListener(
    FileServiceEventsEnum.MAIN_TO_RENDERER_FILE_DOWNLOAD_FAILED,
    () => {
      notify.error('File downloading failed! Please try again');
    }
  );

  return {
    downloadFileFromUrl,
    downloadCsvFile,
  };
};
